import { render } from "./SectionOne.vue?vue&type=template&id=427ff772&scoped=true"
const script = {}

import "./SectionOne.vue?vue&type=style&index=0&id=427ff772&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427ff772"]])

export default __exports__